/**
 * Shared constants for the Trader / match list: sport mapping, refresh interval, and cricket stream reconnect settings.
 */

export const SPORT_MAP: Record<string, string> = {
    CRICKET: "cricket",
    HORSES: "horses",
    FOOTBALL: "football",
    TENNIS: "tennis",
};

/** Interval for background refresh of match list (ms). */
export const TRADER_REFRESH_INTERVAL_MS = 30000;

/** When no sport tab is selected, all four sports are fetched in parallel — poll less often to reduce load. */
export const TRADER_REFRESH_ALL_SPORTS_INTERVAL_MS = 60000;

/** Cricket stream reconnect: delay before first retry (ms). */
export const STREAM_FIRST_RETRY_MS = 3000;
/** Cricket stream reconnect: interval between subsequent retries (ms). */
export const STREAM_RETRY_INTERVAL_MS = 5000;
/** Cricket stream reconnect: max automatic retries before giving up. */
export const STREAM_MAX_AUTO_RETRIES = 4;

/**
 * Live cricket: trader **list** stream / trade gate — treat as stale after this long without
 * an SSE JSON message (align with backend MATCH_WS_STALE_IN_PLAY_MS).
 */
export const CRICKET_LIVE_STALE_AFTER_MS = 90_000;

/**
 * Match page: timer interval for optional `GET /stream/initial-state` catch-up (tab visible).
 * Skipped while SSE recently delivered data — see `TRADER_MATCH_SNAPSHOT_SKIP_IF_SSE_RECENT_MS`.
 */
export const TRADER_MATCH_SNAPSHOT_POLL_MS = 18_000;

/**
 * If the match EventSource delivered any payload within this window, skip the timed snapshot fetch.
 * Reduces concurrent HTTP during live play (mobile networks); when the stream goes quiet, polling resumes.
 * Keep slightly above POLL_MS so healthy SSE suppresses most redundant snapshot polls.
 * Exception: leaving MATCH_SCHEDULED / Pre Match Service forces one snapshot regardless (detail tabs).
 */
export const TRADER_MATCH_SNAPSHOT_SKIP_IF_SSE_RECENT_MS = 22_000;

/**
 * Match markets UI: show “no recent updates” / block stale trades only after this long without a
 * market snapshot (separate from list feed gate; avoids aggressive reconnect during slow overs).
 */
export const TRADER_MATCH_TAB_STALE_AFTER_MS = 5 * 60 * 1000;
